import { Typography, TypographyProps } from '@mui/material';
import clsx from 'clsx';
import { ReactNode, forwardRef } from 'react';

import styles from './IconTypography.module.scss';


interface IconTypographyProps extends TypographyProps {
    children: ReactNode;
    icon: ReactNode;
    iconPosition?: 'before' | 'after';
    compact?: boolean;
}

export const IconTypography = forwardRef<HTMLSpanElement, IconTypographyProps>(({
    children, className, icon, iconPosition, compact, ...props
}, ref) => (
    <Typography
        className={clsx(styles.root, className, {
            [styles.compact]: compact
        })}
        {...props}
        ref={ref}
    >
        {iconPosition === 'before' ? icon : children}

        {iconPosition === 'before' ? children : icon}
    </Typography>
));

IconTypography.defaultProps = {
    iconPosition: 'before',
    fontWeight: 500
};
